// pages/CeilingCoatingService.jsx
// import React from "react";

// export default function CeilingCoatingService() {
//   return (
//    <div className="page-container">

//       {/* Hero */}
//       <section
//         className="hero"
//         style={{ backgroundImage: "url('/images/residential-interior.jpg')" }}
//       >
//         <div className="hero-overlay"></div>
//         <h1 className="hero-title">Residential Interior Painting</h1>
//       </section>

//       {/* Intro */}
//       <section className="section">
//         <p>
//           Transform your home with our expert residential interior painting services.
//           Whether it’s a single room or your entire house, we provide flawless finishes
//           and color combinations that make your space feel warm and inviting.
//         </p>
//       </section>

//       {/* Why Choose Us */}
//       <section className="section bg-light">
//         <h2>Why Choose Us</h2>
//         <div className="why-list">
//           <div className="why-item">
//             <i className="fas fa-check-circle"></i>
//             <p>Premium paints and eco-friendly materials</p>
//           </div>
//           <div className="why-item">
//             <i className="fas fa-clock"></i>
//             <p>On-time project completion</p>
//           </div>
//           <div className="why-item">
//             <i className="fas fa-paint-roller"></i>
//             <p>Skilled painters with years of experience</p>
//           </div>
//           <div className="why-item">
//             <i className="fas fa-smile"></i>
//             <p>Customer satisfaction guaranteed</p>
//           </div>
//         </div>
//       </section>

//       {/* Process */}
//       <section className="section">
//         <h2>Our Process</h2>
//         <ol className="process-list">
//           <li>Free consultation & color selection</li>
//           <li>Surface preparation (cleaning & sanding)</li>
//           <li>Primer & multiple paint coats</li>
//           <li>Final touch-ups & inspection</li>
//         </ol>
//       </section>

//       {/* Gallery */}
//       <section className="section bg-light">
//         <h2>Recent Projects</h2>
//         <div className="gallery">
//           <img src="/images/interior1.jpg" alt="Project 1" />
//           <img src="/images/interior2.jpg" alt="Project 2" />
//           <img src="/images/interior3.jpg" alt="Project 3" />
//         </div>
//       </section>

//       {/* Contact Form */}
//       <section className="section">
//         <h2>Get a Free Quote</h2>
//         <form className="contact-form">
//           <input type="text" placeholder="Your Name" />
//           <input type="email" placeholder="Your Email" />
//           <input type="tel" placeholder="Your Phone" />
//           <textarea placeholder="Project Details"></textarea>
//           <button type="submit">Submit</button>
//         </form>
//       </section>

//     </div>
//   );
// }



import React from "react";

// import "./serviceDetail.css";
// import ServiceContactForm from "../pages/servicecontactform";
import ContactForm from "../pages/Contact";


export default function CeilingCoating() {
  return (
    <div className="page-container">

      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/Gallerypics/photo-1631679706909-1844bbd07221.jpeg')" }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">Ceiling Coating</h1>
      </section>

      {/* Intro */}
      <section className="section">
        <p>
          We provide expert ceiling coating solutions for commercial and
          residential interiors. Our coatings enhance aesthetics, resist
          moisture, and provide long-lasting protection for ceilings in homes,
          offices, and industrial spaces.
        </p>
      </section>

      {/* Why Choose Us */}
      <section className="section bg-light">
        <h2>Why Choose Us</h2>
        <div className="why-list">
          <div className="why-item">
            <i className="fas fa-brush"></i>
            <p>Perfect, even ceiling finishes</p>
          </div>
          <div className="why-item">
            <i className="fas fa-tint"></i>
            <p>Moisture and stain-resistant coatings</p>
          </div>
          <div className="why-item">
            <i className="fas fa-sun"></i>
            <p>UV and mold protection</p>
          </div>
          <div className="why-item">
            <i className="fas fa-clock"></i>
            <p>Quick, clean application process</p>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section">
        <h2>Our Process</h2>
        <ol className="process-list">
          <li>Inspection & ceiling surface assessment</li>
          <li>Cleaning & surface preparation</li>
          <li>Application of primer & specialized coatings</li>
          <li>Final smooth finish & inspection</li>
        </ol>
      </section>

      {/* Gallery */}
      <section className="section bg-light">
        <h2>Recent Projects</h2>
        <div className="gallery">
          <img src="/Gallerypics/photo-1631679706909-1844bbd07221.jpeg" alt="Ceiling Project 1" />
          <img src="/Project pics/ceiling.jpg" alt="Ceiling Project 2" />
          <img src="/Gallerypics/tennis-court-render-3d-illustration.jpg" alt="Ceiling Project 3" />
        </div>
      </section>

      {/* Contact Form */}
      <ContactForm/>
      


    </div>
  );
}
